import React, { useCallback, useState } from 'react';
import InformationCircleOutlineIcon from 'mdi-react/InformationCircleOutlineIcon';
import OpenInNewIcon from 'mdi-react/OpenInNewIcon';
import { useSelector } from 'react-redux';
import ContentCopyIcon from 'mdi-react/ClipboardArrowLeftIcon';

import { ReduxInject } from '@crm-framework/saga-injector';
import { CopyIconButtonWithoutNotify } from '@crm-framework/copy-icon-button';
import { IconButton } from '@crm-framework/icon-button';

import { LeadShortInfoPopover } from '../LeadShortInfoPopover';
import { getLeadShortInfoState } from '../utils';
import { leadShortInfoReducer, STORE_NAME } from '../store';
import { watchShortLeadInfo } from '../sagas';
import { ActiveElement } from '../LeadShortInfoPopover/styled';

import {
  ILeadGridFormatterTemplateExtraStyles,
  Wrapper,
  ButtonWrapper,
  LeadNavLink,
} from './styled';

interface ILeadGridFormatterTemplateProps
  extends ILeadGridFormatterTemplateExtraStyles {
  leadId: number;
  demo?: boolean;
  showInfo?: boolean;
  showNewTab?: boolean;
}

export const LeadGridFormatterTemplate: React.FC<
  ILeadGridFormatterTemplateProps
> = ({ leadId, showInfo, showNewTab, ...styles }) => {
  const { hasRightForWatchInfo } = useSelector(getLeadShortInfoState);
  const [isOpen, setIsOpen] = useState(false);

  const handleStopPropagation = useCallback((e) => e.stopPropagation(), []);
  const handleOpenPopover = useCallback((e) => {
    e.stopPropagation();
    setIsOpen(true);
  }, []);

  return (
    <Wrapper justifyContent={styles.justifyContent}>
      <LeadNavLink to={`/${leadId}`} onClick={handleStopPropagation}>
        {leadId}
      </LeadNavLink>
      <ButtonWrapper>
        <CopyIconButtonWithoutNotify
          text={String(leadId)}
          tooltip="Copied"
          onClick={handleStopPropagation}>
          <IconButton
            icon={ContentCopyIcon}
            withHover
            size="xs"
            appearance="info"
          />
        </CopyIconButtonWithoutNotify>
        {showInfo && hasRightForWatchInfo && (
          <LeadShortInfoPopover
            leadId={leadId}
            position="right top"
            positionFixed
            visible={isOpen}
            onOutsideClick={() => setIsOpen(false)}
            autoFlip>
            <IconButton
              icon={InformationCircleOutlineIcon}
              appearance="info"
              size="xs"
              withHover
              onClick={handleOpenPopover}
              padding="0"
            />
          </LeadShortInfoPopover>
        )}

        {showNewTab && (
          <ActiveElement>
            <IconButton
              icon={OpenInNewIcon}
              appearance="info"
              size="xs"
              withHover
              onClick={handleStopPropagation}
              withPreventDefault={false}
              href={`/lead/${leadId}`}
              target="_blank"
              padding="0"
            />
          </ActiveElement>
        )}
      </ButtonWrapper>
    </Wrapper>
  );
};

export const LeadGridFormatterTemplateWithInject: React.FC<
  ILeadGridFormatterTemplateProps
> = (props) => (
  <ReduxInject
    keyName={STORE_NAME}
    reducer={leadShortInfoReducer}
    saga={watchShortLeadInfo}>
    <LeadGridFormatterTemplate {...props} />
  </ReduxInject>
);
